import camelcaseKeys from 'camelcase-keys';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { Configuration, IRequest } from '../../request/Types';
import type { DeviceStatus } from './Types';

export class DeviceStatusRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getDevicesStatus = async (): Promise<DeviceStatus[]> => {
    const requestData: IRequest = {
      endpoint: '/devices-status',
      method: HttpMethod.GET,
    };

    const { data } = await this.requester.request(requestData);
    return camelcaseKeys(data, { deep: true });
  };
}

export default DeviceStatusRequester;
